<template>
    <div class="error-bubble" v-html="ErrorText" v-show="IsVisible"></div>
</template>

<script>


export default {
  name: 'GrcCompErrorBubble',
  components: {
  },
  props: {
  },
  data () {
      return {
          IsVisible: false,
          ErrorText: ""
      }
  },
  model: {
  },  
  methods:{
      ShowError(pText)
      {
          this.ErrorText = pText;
          this.IsVisible = true;
      },

      HideError()
      {
          this.IsVisible = false;
      }

  },
  created()
  {

  },
  mounted()
  {

  }

}


</script>


<style scoped>

.error-bubble {
	position: relative;
	background: #8d415c;
  border-radius: 6px;
  
  width: 100%;
    box-sizing: border-box;
    font-family: "PremiumDefault";
    font-size: 14px;
    line-height: 16px;
    color: #fff;
    margin-top: 8px;
    padding: 8px;
    margin-bottom: 16px;  
}

.error-bubble:after {
	content: '';
	position: absolute;
	top: 0;
	left: 16px;
	width: 0;
	height: 0;
	border: 4px solid transparent;
	border-bottom-color: #8d415c;
	border-top: 0;
	margin-left: -4px;
	margin-top: -4px;
}



</style>